import { render, staticRenderFns } from "./PricingPage.vue?vue&type=template&id=c1ecaec2&scoped=true&"
import script from "./PricingPage.vue?vue&type=script&lang=ts&"
export * from "./PricingPage.vue?vue&type=script&lang=ts&"
import style0 from "./PricingPage.vue?vue&type=style&index=0&id=c1ecaec2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ecaec2",
  null
  
)

export default component.exports